import { NgModule } from '@angular/core';
import { DragAndDropDirective } from './drag-and-drop/drag-and-drop.directive';
import { SortableDirective } from './sortable/sortable.directive'

@NgModule({
    declarations: [
        SortableDirective,
        DragAndDropDirective
    ],
    imports: [],
    exports: [
        SortableDirective,
        DragAndDropDirective
    ]
})
export class DirectiveModule { }
